import { Card, CardMeta, CardTitle } from '@/design/components';
import { useMe } from '@/auth/useMe';
import { fullName } from '@/auth/me.types';
import { formatDate, now } from '@/lib/dates';
import { ManagerShortcuts } from './ManagerShortcuts';
import { SpotlightCard } from '@/features/products/SpotlightCard';
import { AwardsCard, CelebrationsCard } from '@/features/games/HomeCards';
import { OpsCard } from '@/features/ops/HomeCard';
import { OnboardingCard } from '@/features/onboarding/OnboardingCard';
import { InstallCard } from '@/features/install/InstallCard';

/**
 * מסך הבית, שלב 0: כרטיס הברכה בלבד.
 * שאר הכרטיסים (משמרת הבאה, מחכה לאישור, לומדות וכו') נכנסים בשלבים 1 עד 6,
 * כולם מתוך ה RPC המרוכזת my_home() (מסמך התכנון, סעיף 9.1).
 */
export function HomePage() {
  const { me } = useMe();
  if (!me) return null;

  const branch = me.branches.find((item) => item.id === me.primaryBranchId) ?? me.branches[0];

  return (
    <div className="grid content-start gap-6 bg-cream p-4">
      <Card>
        <CardTitle>
          {greeting()}, {me.firstName}
        </CardTitle>
        <CardMeta>{formatDate(now())}</CardMeta>
        <CardMeta>
          {[branch?.name, me.jobTitle].filter(Boolean).join(' · ') || fullName(me)}
        </CardMeta>
      </Card>

      {/* ההזמנה להתקין יושבת מעל הכל כל עוד האפליקציה אינה
          מותקנת, ונעלמת ברגע שהיא כן */}
      <InstallCard />

      <OnboardingCard />

      <OpsCard />

      <AwardsCard />

      <SpotlightCard />

      <CelebrationsCard />

      <ManagerShortcuts />
    </div>
  );
}

function greeting(): string {
  const hour = now().getHours();
  if (hour < 12) return 'בוקר טוב';
  if (hour < 18) return 'צהריים טובים';
  return 'ערב טוב';
}
